import { ActionIcon, Indicator } from '@mantine/core';
import { IconBell } from '@tabler/icons-react';
import { useNotifications } from 'src/notifications/hooks/useNotifications';
import { unreadCount } from 'src/notifications/notificationFilters';
import { useNotificationDrawerStore } from 'src/notifications/useNotificationDrawerStore';
import NotificationDrawer from './NotificationDrawer';

export default function NotificationBell() {
  const opened = useNotificationDrawerStore(state => state.opened);
  const open = useNotificationDrawerStore(state => state.open);
  const close = useNotificationDrawerStore(state => state.close);
  const { data } = useNotifications();
  const count = unreadCount(data ?? []);

  return (
    <>
      <Indicator
        color="brand"
        size={16}
        offset={6}
        disabled={count === 0}
        label={count > 0 ? count : undefined}
      >
        <ActionIcon
          variant="transparent"
          size={42}
          onClick={() => open()}
          aria-label="Notifications"
        >
          <IconBell size={24} color="white" />
        </ActionIcon>
      </Indicator>
      <NotificationDrawer opened={opened} onClose={close} />
    </>
  );
}
